import { render, staticRenderFns } from "./pc-leg-switch-with-value.vue?vue&type=template&id=bdd873e4&"
import script from "./pc-leg-switch-with-value.vue?vue&type=script&lang=js&"
export * from "./pc-leg-switch-with-value.vue?vue&type=script&lang=js&"
import style0 from "./pc-leg-switch-with-value.vue?vue&type=style&index=0&id=bdd873e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports